import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { ref as x } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { watch as m } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function T(t) {
  let r = 0;
  for (const c of t)
    r++;
  return r;
}
function b(t) {
  return t === "" || t == null;
}
function w(t) {
  const r = x(null);
  function c() {
    const {
      value: e
    } = t;
    if (!(e != null && e.focus)) {
      u();
      return;
    }
    const {
      selectionStart: l,
      selectionEnd: n,
      value: o
    } = e;
    if (l == null || n == null) {
      u();
      return;
    }
    r.value = {
      start: l,
      end: n,
      beforeText: o.slice(0, l),
      afterText: o.slice(n)
    };
  }
  function d() {
    var e;
    const {
      value: l
    } = r, {
      value: n
    } = t;
    if (!l || !n)
      return;
    const {
      value: o
    } = n, {
      start: f,
      beforeText: i,
      afterText: a
    } = l;
    let s = o.length;
    if (o.endsWith(a))
      s = o.length - a.length;
    else if (o.startsWith(i))
      s = i.length;
    else {
      const h = i[f - 1], v = o.indexOf(h, f - 1);
      v !== -1 && (s = v + 1);
    }
    (e = n.setSelectionRange) === null || e === void 0 || e.call(n, s, s);
  }
  function u() {
    r.value = null;
  }
  return m(t, u), {
    recordCursor: c,
    restoreCursor: d
  };
}
export {
  b as isEmptyInputValue,
  T as len,
  w as useCursor
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/input/src/utils.js
// module id = 922
// module chunks = 41